import React from 'react';
import { Grid, Skeleton } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  chartSkeleton: {
    width: '100%',
    height: theme.spacing(4),
    margin: `${theme.spacing(1.5)} 0`,
    backgroundColor: theme.skelton.color,
    borderRadius: theme.spacing(0.5)
  },
  legendSkeleton: {
    width: '100%',
    margin: `${theme.spacing(1)} 0`,
    backgroundColor: theme.skelton.color
  },
  legendContainer: {
    height: theme.spacing(8),
    overflow: 'hidden',
    backgroundColor: theme.skelton.color,
    borderRadius: theme.spacing(0.5)
  },
  container: {
    height: theme.spacing(67)
  }
}));
const SourceByTimeChartSkeleton: React.FC = () => {
  const classes = useStyles();

  return (
    <Grid
      container
      data-testid={'source-by-time-chart-skeleton'}
      className={classes.container}
      alignContent="flex-start"
    >
      <Grid item xs={12}>
        <Skeleton className={classes.chartSkeleton} variant="rectangular" />
      </Grid>
      <Grid item xs={12} className={classes.legendContainer}>
        <Skeleton
          className={classes.legendSkeleton}
          height="70%"
          variant="rectangular"
        />
      </Grid>
    </Grid>
  );
};

export default SourceByTimeChartSkeleton;
